import { FC, ReactNode, createContext, useContext, useMemo } from "react";

import type { PopupImportFunnelOption } from "./popupImportFunnelOptions";

type Ctx = {
  funnelOptions: PopupImportFunnelOption[];
};

const PopupImportFunnelOptionsContext = createContext<Ctx | null>(null);

export const PopupImportFunnelOptionsProvider: FC<{
  funnelOptions: PopupImportFunnelOption[];
  children: ReactNode;
}> = ({ funnelOptions, children }) => {
  const value = useMemo(() => ({ funnelOptions }), [funnelOptions]);
  return (
    <PopupImportFunnelOptionsContext.Provider value={value}>
      {children}
    </PopupImportFunnelOptionsContext.Provider>
  );
};

export function usePopupImportFunnelOptions(): Ctx {
  const v = useContext(PopupImportFunnelOptionsContext);
  if (!v) {
    throw new Error(
      "usePopupImportFunnelOptions must be used within PopupImportFunnelOptionsProvider"
    );
  }
  return v;
}
